// Postcode Anywhere Javascript Popup Service
// Version 3.0 (SlipStream engine enabled)
// Automatically generated on 19/06/2012 10:12:15 from WEB-1-2
// (c) 2001-2012 Postcode Anywhere (Europe) Ltd
import Track from '../v2/utils/tracking';

const pcaBaseUrlJR17 = 'https://services.postcodeanywhere.co.uk/popups';
const pcaLicenseKeyJR17 = 'JR17-HJ62-YH17-FE42';
const pcaAccountCodeJR17 = 'THEHU11117';
const pcaMachineIdJR17 = '';
const pcaInlineServiceJR17 = `${pcaBaseUrlJR17}/inline.aspx`;
const pcaReturnUrlJR17 = window.location;
let pcaNextStepJR17 = '';
let _callbackToSetAddress;

function pcaGetFieldJR17(what) {
  for (let intFormCounter = 0; intFormCounter <= document.forms.length - 1; intFormCounter++) {
    for (let elementCounter = 0; elementCounter <= document.forms[intFormCounter].length - 1; elementCounter++) {
      if (document.forms[intFormCounter].elements[elementCounter].name == what) {
        return document.forms[intFormCounter].elements[elementCounter].value;
      }
    }
  }
}

function pcaFindJR17() {
  const strPostcode = pcaGetFieldJR17('paymentCard.billingAddress.postCode');
  
  if (strPostcode.length <= 4) {
    pcaByOutcodeBeginJR17(strPostcode);
  } else {
    pcaByPostcodeBeginJR17(strPostcode);
  }
}

function pcaByPostcodeBeginJR17(postcode) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  // Build the url
  const strUrl = `${pcaInlineServiceJR17}?account_code=${escape(pcaAccountCodeJR17)}&license_code=${escape(pcaLicenseKeyJR17)}&machine_id=${escape(pcaMachineIdJR17)}&return_to=${escape(pcaReturnUrlJR17)}&action=lookup&type=by_postcode&callback=pcaByPostcodeEndJR17&postcode=${escape(postcode)}`;
  
  // Clear the list
  document.getElementById('pcaSelectJR17').length = 0;
  
  // Set the next step
  pcaNextStepJR17 = 'FETCH';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

function handlePCACallback() {
  let intCounter = 0;
  
  // Test for an error
  if (pcaSchema.length == 2) {
    // Show the error message
    Track.track(pca_message[0]);
  } else {
    // Add the items to the list
    const select = document.getElementById('pcaSelectJR17');
    select.length = pcaRecordCount;
    
    for (intCounter = 0; intCounter < pcaRecordCount; intCounter++) {
      select.options[intCounter].text = pca_description[intCounter];
      select.options[intCounter].value = pca_id[intCounter];
    }
    
    const fallbackOpts = document.createElement('option');
    fallbackOpts.setAttribute('selected', 'selected');
    fallbackOpts.setAttribute('disabled', 'disabled');
    fallbackOpts.innerHTML = 'Please select...';
  
    select.add(fallbackOpts, select.firstChild);
  
    // Check if there were any items listed
    if (pcaRecordCount == 0) {
      select.length = 1;
      select.options[intCounter].text = siteObj.props['checkout-pca-no-matching-items-text'];
      select.options[intCounter].value = '';
      select.disabled = true;
    } else {
      select.selectedIndex = 0; // Fixes strange bug on FF where going from disabled to non-disabled option wouldn't update.
      select.disabled = false;
    }
    
    // Show the list
    select.style.visibility = 'visible';
    document.getElementById('pcaDivJR17').style.display = '';
  }
}

const pcaByPostcodeEndJR17 = handlePCACallback;

function pcaByOutcodeBeginJR17(outcode) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  const strUrl = `${pcaInlineServiceJR17}?account_code=${escape(pcaAccountCodeJR17)}&license_code=${escape(pcaLicenseKeyJR17)}&machine_id=${escape(pcaMachineIdJR17)}&return_to=${escape(pcaReturnUrlJR17)}&action=lookup&type=by_outcode&callback=pcaByOutcodeEndJR17&outcode=${escape(outcode)}`;
  
  // Clear the list
  document.getElementById('pcaSelectJR17').length = 0;
  
  // Set the next step
  pcaNextStepJR17 = 'BY_LOCALITYKEY';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

const pcaByOutcodeEndJR17 = handlePCACallback;

function pcaByLocalityKeyBeginJR17(localityKey) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  const strUrl = `${pcaInlineServiceJR17}?account_code=${escape(pcaAccountCodeJR17)}&license_code=${escape(pcaLicenseKeyJR17)}&machine_id=${escape(pcaMachineIdJR17)}&return_to=${escape(pcaReturnUrlJR17)}&action=lookup&type=by_localitykey&callback=pcaByLocalityKeyEndJR17&localitykey=${escape(localityKey)}`;
  
  // Clear the list
  document.getElementById('pcaSelectJR17').length = 0;
  
  // Set the next step
  pcaNextStepJR17 = 'BY_STREETKEY';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

const pcaByLocalityKeyEndJR17 = handlePCACallback;

function pcaByStreetKeyBeginJR17(streetKey) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  const strUrl = `${pcaInlineServiceJR17}?account_code=${escape(pcaAccountCodeJR17)}&license_code=${escape(pcaLicenseKeyJR17)}&machine_id=${escape(pcaMachineIdJR17)}&return_to=${escape(pcaReturnUrlJR17)}&action=lookup&type=by_streetkey&callback=pcaByStreetKeyEndJR17&streetkey=${escape(streetKey)}`;
  
  // Clear the list
  document.getElementById('pcaSelectJR17').length = 0;
  
  // Set the next step
  pcaNextStepJR17 = 'FETCH';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

function pcaByStreetKeyEndJR17() {
  let intCounter = 0;
  
  // Test for an error
  if (pcaSchema.length == 2) {
    // Show the error message
    Track.track(pca_message[0]);
  } else {
    // Add the items to the list
    const select = document.getElementById('pcaSelectJR17');
    select.length = pcaRecordCount;
  
    for (intCounter = 0; intCounter < pcaRecordCount; intCounter++) {
      select.options[intCounter].text = pca_description[intCounter];
      select.options[intCounter].value = pca_id[intCounter];
    }
  
    // Check if there were any items listed
    if (pcaRecordCount == 0) {
      select.length = 1;
      select.options[intCounter].text = siteObj.props['checkout-pca-no-matching-items-text'];
      select.options[intCounter].value = '';
      select.disabled = true;
    } else {
      select.selectedIndex = 0;
      select.disabled = false;
    }
  
    // Show the list
    select.style.visibility = 'visible';
    select.onblur = pcaDoSelectJR17;
    document.getElementById('pcaDivJR17').style.display = '';
  }
}

function pcaDoSelectJR17(event) {
  const {value} = event.target;
  switch (pcaNextStepJR17) {
    case 'FETCH':
      pcaFetchBeginJR17(value);
      break;
    case 'BY_LOCALITYKEY':
      pcaByLocalityKeyBeginJR17(value);
      break;
    case 'BY_STREETKEY':
      pcaByStreetKeyBeginJR17(value);
      break;
  }
}

function pcaFetchBeginJR17(addressId) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  document.getElementById('pcaDivJR17').style.display = 'none';
  
  // Build the url
  const strUrl = `${pcaInlineServiceJR17}?account_code=${escape(pcaAccountCodeJR17)}&license_code=${escape(pcaLicenseKeyJR17)}&machine_id=${escape(pcaMachineIdJR17)}&return_to=${escape(pcaReturnUrlJR17)}&action=fetch&callback=pcaFetchEndJR17&id=${escape(addressId)}`;
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

function pcaFetchEndJR17() {
  // Test for an error
  if (pcaSchema.length == 2) {
    // Show the error message
    Track.track(pca_message[0]);
  } else if (_callbackToSetAddress) {
    const addressValues = {
      county: pca_PAF_COUNTY[0],
      // postCode: pca_PAF_POSTCODE[0], // TODO: Investigate why AH71 (delivery) gets postcode but this does not
      nameNumber: pca_PAF_BUILDING[0],
      streetName: pca_PAF_STREET[0],
      townCity: pca_PAF_TOWN[0],
      addressLine2: pca_PAF_DISTRICT[0],
      companyName: pca_PAF_COMPANY[0],
    };
    _callbackToSetAddress(addressValues);
  } else {
    // Copy the items to the form
    pcaSetFieldJR17('paymentCard.billingAddress.county', pca_PAF_COUNTY[0]);
    pcaSetFieldJR17('paymentCard.billingAddress.nameNumber', pca_PAF_BUILDING[0]);
    pcaSetFieldJR17('paymentCard.billingAddress.streetName', pca_PAF_STREET[0]);
    pcaSetFieldJR17('paymentCard.billingAddress.townCity', pca_PAF_TOWN[0]);
    pcaSetFieldJR17('paymentCard.billingAddress.addressLine2', pca_PAF_DISTRICT[0]);
    pcaSetFieldJR17('paymentCard.billingAddress.companyName', pca_PAF_COMPANY[0]);
  }
}

function pcaSetFieldJR17(what, newValue) {
  for (let intFormCounter = 0; intFormCounter <= document.forms.length - 1; intFormCounter++) {
    for (let elementCounter = 0; elementCounter <= document.forms[intFormCounter].length - 1; elementCounter++) {
      if (document.forms[intFormCounter].elements[elementCounter].name == what) {
        document.forms[intFormCounter].elements[elementCounter].value = newValue;
      }
    }
  }
}

function setCallbackToSetAddress(callbackToSetAddress) {
  _callbackToSetAddress = callbackToSetAddress;
}

window.pcaByPostcodeEndJR17 = pcaByPostcodeEndJR17;
window.pcaByOutcodeEndJR17 = pcaByOutcodeEndJR17;
window.pcaByLocalityKeyEndJR17 = pcaByLocalityKeyEndJR17;
window.pcaByStreetKeyEndJR17 = pcaByStreetKeyEndJR17;
window.pcaFetchEndJR17 = pcaFetchEndJR17;

export default {
  find: pcaFindJR17,
  doSelect: pcaDoSelectJR17,
  setCallbackToSetAddress,
  embedCode: 'JR17',
};
